import React from "react";
import { Link } from "react-router-dom";
import { menuItems } from "../../../../landing/data";
import SiteLogo from "../../../SiteLogo";

export default function LandingHeader() {
  return (
    <div className="fixed top-0 z-50 justify-center hidden w-full h-24 bg-white xl:flex shadow-blue-sass-sh">
      <div className="px-[70px] w-full">
        <header className="relative flex items-center justify-between w-full h-full py-6 mx-auto">
          <SiteLogo />
          <ul className="flex items-center gap-10 text-base font-medium leading-5 text-main-black font-inter h-fit">
            {menuItems.map((menu, index) => (
              <li key={index}>
                <a
                  href={menu.link}
                  className={`home-two-nav-item relative before:content-[${menu.label}] before:text-blue-sass before:border-blue-sass before:h-[20px]`}
                >
                  {menu.label}
                </a>
              </li>
            ))}
          </ul>
          <div className="flex items-center gap-7">
            <Link to="https://portal.bpay.rw/" target="_blank">
              <div className="home-two-btn-white-rev home-two-btn-white-rev-sm group bg-blue-sass border-blue-sass">
                <span className="relative z-10 text-base font-semibold text-white transition-all duration-300 group-hover:text-blue-sass font-inter">
                  Bike Owner Portal
                </span>
                <svg
                  className="relative z-10"
                  width="7"
                  height="12"
                  viewBox="0 0 7 12"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    className="transition-all duration-300 group-hover:stroke-blue-sass stroke-white"
                    d="M1.10254 10.5L4.89543 6.70711C5.22877 6.37377 5.39543 6.20711 5.39543 6C5.39543 5.79289 5.22877 5.62623 4.89543 5.29289L1.10254 1.5"
                    stroke="white"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </div>
            </Link>
          </div>
        </header>
      </div>
    </div>
  );
}
